export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ["currentData", "config", "owner", "designer", "isMobile"],
  methods: {
    yes() { },
    validate() {
      return true;
    },
    setCtrlType(){
      if (this.$el && this.$el.nodeType == 1) {
        this.$el.setAttribute('ctrl_type', this.$options.name || "")
      }
    }
  },
  mounted() {
    this.setCtrlType()
  },
  updated() {
    this.setCtrlType()
  }
};
